import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4;
import { BORDER_RADIUS } from "../../../constants/borders";
import mediaQueries from "../../../util/mediaqueries";
import styled, { css } from 'styled-components';
import { Widget } from '@typeform/embed-react';
import GridContainer from "../../grid-container";
export var Container = styled(GridContainer).withConfig({
  componentId: "sc-1xpiq02-0"
})(["padding:64px 0;", ";"], mediaQueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 96px 0;\n  "]))))));
export var TypeformContainer = styled.div.withConfig({
  componentId: "sc-1xpiq02-1"
})(["grid-column:1 / -1;height:480px;border-radius:", ";overflow:hidden;", ";"], BORDER_RADIUS.large, mediaQueries.lg(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: 536px;\n  "]))))));
export var TypeformElement = styled(Widget).withConfig({
  componentId: "sc-1xpiq02-2"
})(["height:100%;width:100%;border:none;", ";"], function (_ref) {
  var aspectRatio = _ref.aspectRatio;
  return aspectRatio && css(["aspect-ratio:", ";"], aspectRatio);
});
export var CTAContainer = styled.div.withConfig({
  componentId: "sc-1xpiq02-3"
})(["grid-column:1 / -1;padding-top:40px;", ";", ";"], mediaQueries.sm(_t3 || (_t3 = _(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin: 0 auto;\n  "]))))), mediaQueries.md(_t4 || (_t4 = _(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    grid-column: 2 / -2;\n  "]))))));